const validation = {
  required: 'generic.required',
  email: 'generic.valid_email',
  passwordWeak: 'error.generic.password.weak',
}

export default validation
